import React from 'react';
import { Box, Typography } from '@mui/material';
import { EventData } from '../../types/event';
import { getDeadlineDiffDays } from '../../utils/dateUtils';

interface DeadlineLabelProps {
  event: EventData;
}

const Badge: React.FC<{
  label: string;
  bgColor: string;
  textColor: string;
}> = ({ label, bgColor, textColor }) => (
  <Box
    component="span"
    sx={{
      display:         'inline-block',
      backgroundColor: bgColor,
      color:           textColor,
      borderRadius:    '4px',
      px:              0.75,
      py:              0.25,
      fontSize:        '0.7rem',
      fontWeight:      700,
      lineHeight:      1.4,
    }}
  >
    {label}
  </Box>
);

/**
 * 締切ラベル表示コンポーネント。
 * - is_past = true          → 「終了済み」（グレーバッジ）
 * - diffDays < 0            → 「申込締切済み」（グレーバッジ）
 * - diffDays === 0          → 「本日締切」（赤バッジ）
 * - diffDays === 1          → 「明日締切」（オレンジバッジ）
 * - diffDays >= 2           → 「締切まで N日」（グレーテキスト）
 * - deadline なし           → 非表示
 */
export const DeadlineLabel: React.FC<DeadlineLabelProps> = ({ event }) => {
  if (event.is_past) {
    return <Badge label="終了済み" bgColor="#EEEEEE" textColor="#9E9E9E" />;
  }

  if (!event.application_deadline) return null;

  const diffDays = getDeadlineDiffDays(event.application_deadline);

  if (diffDays < 0) {
    return <Badge label="申込締切済み" bgColor="#F5F5F5" textColor="#9E9E9E" />;
  }

  if (diffDays === 0) {
    return <Badge label="本日締切" bgColor="#FFEBEE" textColor="#D32F2F" />;
  }

  if (diffDays === 1) {
    return <Badge label="明日締切" bgColor="#FFF3E0" textColor="#E65100" />;
  }

  return (
    <Typography variant="caption" sx={{ color: '#757575', fontWeight: 500 }}>
      締切まで{diffDays}日
    </Typography>
  );
};
